import React, {useState} from "react";
import './_signin.scss';
import {useDispatch, useSelector} from "react-redux";
import {setSent} from "../redux/actions/UIActions";
import {useQueryParam} from "../utilities/UseQueryParams";

export const GetSignInTemplate = (company, application) => {
    let wait = useQueryParam("ShouldWait");
    wait = (wait !== 'false');
    const [shouldWait] = useState(wait);
    const [timeRemaining, setTimeRemaining] = useState(10);

    let executeSignIn = () => {
        dispatch(setSent());
        setTimeRemaining(0);
        company.signInHandler();
    }

    const sent = useSelector((state) => state.UIReducer.sent)
    const dispatch = useDispatch();
    if (!sent) {
        if (shouldWait) {
            setTimeout(() => {
                if (timeRemaining > 0) {
                    setTimeRemaining(timeRemaining - 1);
                } else if (timeRemaining === 0 && sent === false) {
                    dispatch(setSent());
                    company.signInHandler();
                }
            }, 1000)
        } else {
            executeSignIn()
        }
    }
    return (
        <div className={"sign-in-container"}>
            <div className={"sign-in-container__title"}>{company.name} Sign-In To {application.name}</div>
            <div>{company.name} clients must use {company.identityProvider} to log into {application.name}.</div>
            <div>Please click the image below to continue.</div>
            <img
                className={"sign-in-container__company-image"}
                src={company.logo}
                alt={company.name + "SSO Signin"}
                onClick={() => {
                    if (!sent) {
                        executeSignIn();
                    }
                }}/>
            {timeRemaining === 0 ?
                <div>Forwarding to {company.identityProvider}</div>
                :
                <div>
                    You will be forwarded to {company.identityProvider} in
                    &nbsp;
                    <span>
                        {timeRemaining}
                    </span>
                    &nbsp;
                    second{timeRemaining !== 1 && "s"}.
                </div>
            }
        </div>
    )
}

